var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iframe-editor-container"},[_c('iframe',{ref:"editorIframe",staticClass:"editor-iframe",attrs:{"src":_vm.editorUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }